export default __webpack_public_path__ + "static/media/Q42023.8c95b97d.pdf";